export function getInitials(str: string | undefined): string {
    if (str === undefined) {
        return "";
    }
    const words: string[] = str.split(" ");
    return words[0]?.charAt(0) + (words[1]?.charAt(0) ?? "");
}
